var Backbone= require("backbone");
var Model = require("../../models/preparations/preparations.model.ts");
require("backbonePaginator");
require("compat");

var PaginatedCollection = Backbone.PageableCollection.extend({
	mode: "server",
	model: Model,
	// Initial pagination states
	state:
	{
		pageSize: 25,
		sortKey: "id",
		order: 1,
		firstPage: 0,
		page: 0
	},
	// Be sure to change this based on how your results are structured
	parse : function ( response )
	{
		if(!response.data && !response.content)
		{
			return response;
		}

		var data = response.data;

		/*if ( response.content )
			data = response.content;
		else{
			data = response.data.collection;
		}*/
		this.totalPages = response.data.pagesCount;
		this.state.lastPage = this.totalPages - 1;

		return data;
	},
	// Used by the template
	info : function ()
	{
		var info =
		{
			firstPage : this.state.firstPage,
			page : this.state.currentPage,
			lastPage : this.state.lastPage,
			perPage : this.state.pageSize
		};
		this.information = info;
		return info;
	}
});
module.exports= PaginatedCollection;